module.exports = __webpack_public_path__ + "static/media/toma-muestra.57f107f7.png";